"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBETQueryServiceObjects = exports.setBETQueryPortalObjects = exports.BETInitialQueryIdsDependency = void 0;

var _immutable = require("immutable");

var _hubspotFluxStores = _interopRequireDefault(require("hubspot.flux.stores.NavigationStore"));

var BETInitialQueryIdsDependency = {
  stores: [_hubspotFluxStores.default],
  deref: function deref() {
    var navigation = _hubspotFluxStores.default.get();

    var _navigation$queryPara = navigation.queryParams,
        portalObjectId = _navigation$queryPara.portalObjectId,
        serviceObjectId = _navigation$queryPara.serviceObjectId;

    if (!serviceObjectId && !portalObjectId) {
      return undefined;
    }

    var portalObjectIds = Array.isArray(portalObjectId) ? portalObjectId : [portalObjectId];
    var serviceObjectIds = Array.isArray(serviceObjectId) ? serviceObjectId : [serviceObjectId];
    return (0, _immutable.Map)({
      portalObjectIds: (0, _immutable.List)(portalObjectIds),
      serviceObjectIds: (0, _immutable.List)(serviceObjectIds)
    });
  }
};
exports.BETInitialQueryIdsDependency = BETInitialQueryIdsDependency;

var setBETQueryPortalObjects = function setBETQueryPortalObjects(props) {
  var BETPortalAssociationsForQuery = props.BETPortalAssociationsForQuery,
      BETInitialQueryIds = props.BETInitialQueryIds,
      onSetBETAssociations = props.onSetBETAssociations;
  var portalAssociations = (0, _immutable.List)(BETPortalAssociationsForQuery).filter(function (obj) {
    return BETInitialQueryIds.get('portalObjectIds').contains("" + obj.value);
  }).map(function (portal) {
    return (0, _immutable.Map)({
      label: portal.text,
      objectId: portal.value
    });
  });
  onSetBETAssociations('BETPortalAssociations', portalAssociations);
};

exports.setBETQueryPortalObjects = setBETQueryPortalObjects;

var setBETQueryServiceObjects = function setBETQueryServiceObjects(props) {
  var BETServiceAssociationsForQuery = props.BETServiceAssociationsForQuery,
      BETInitialQueryIds = props.BETInitialQueryIds,
      onSetBETAssociations = props.onSetBETAssociations;
  var serviceAssociations = (0, _immutable.List)(BETServiceAssociationsForQuery).filter(function (obj) {
    return BETInitialQueryIds.get('serviceObjectIds').contains("" + obj.value);
  }).map(function (service) {
    return (0, _immutable.Map)({
      label: service.text,
      objectId: service.value
    });
  });
  onSetBETAssociations('BETServiceAssociations', serviceAssociations);
};

exports.setBETQueryServiceObjects = setBETQueryServiceObjects;